import * as THREE from 'three';
import ObjectView from '../../views/object-view';

export default {
  name: 'rebar-reinforcement-object',
  mode: ObjectView.mode.MODE_3D,
  orientation: 'x',
  camera2D: {
    position: new THREE.Vector3(0.001, 1345.362, 0)
  },
};




// WEBPACK FOOTER //
// ./src/object-view/generators/rebar-reinforcement/defaultOptions.js